// extracted by mini-css-extract-plugin
export var active = "_3b-7";
export var container = "_3b-0";
export var evenWidth = "_3b-4";
export var large = "_3b-5";
export var outlet = "_3b-8";
export var slide = "_3b-2";
export var small = "_3b-6";
export var tab = "_3b-3";
export var tabs = "_3b-1";